/**
 * Gera o payload EMV do Pix (copia e cola) para QR Code estático.
 */

function pad(id, value) {
  const len = value.length.toString().padStart(2, '0');
  return `${id}${len}${value}`;
}

function crc16(str) {
  let crc = 0xFFFF;
  for (let i = 0; i < str.length; i++) {
    crc ^= str.charCodeAt(i) << 8;
    for (let j = 0; j < 8; j++) {
      if (crc & 0x8000) crc = (crc << 1) ^ 0x1021;
      else crc <<= 1;
    }
    crc &= 0xFFFF;
  }
  return crc.toString(16).toUpperCase().padStart(4, '0');
}

/**
 * @param {object} params
 * @param {string} params.chave - Chave Pix (telefone, email, CPF, aleatória)
 * @param {string} params.nome - Nome do recebedor (até 25 chars)
 * @param {string} params.cidade - Cidade do recebedor (até 15 chars)
 * @param {number} params.valor - Valor em reais (ex: 5.01)
 * @param {string} [params.txid] - Identificador da transação (opcional)
 */
export function gerarPixPayload({ chave, nome, cidade, valor, txid }) {
  const merchantAccount = pad('00', 'br.gov.bcb.pix') + pad('01', chave);

  let payload = '';
  payload += pad('00', '01');
  payload += pad('01', '12');
  payload += pad('26', merchantAccount);
  payload += pad('52', '0000');
  payload += pad('53', '986');

  if (valor && valor > 0) {
    payload += pad('54', valor.toFixed(2));
  }

  payload += pad('58', 'BR');
  payload += pad('59', nome.substring(0, 25));
  payload += pad('60', cidade.substring(0, 15));

  if (txid) {
    const additionalData = pad('05', txid.substring(0, 25));
    payload += pad('62', additionalData);
  }

  payload += '6304';
  const checksum = crc16(payload);
  payload += checksum;

  return payload;
}
